import React from 'react';

import AuthProvider from './providers/authProvider';
import DataProvider from './providers/dataProvider';
import i18nProvider from './providers/i18nProvider';

import { Admin, Resource, defaultTheme } from 'react-admin';
//import { dashboard } from './pages/dashboard';
import { MemberList, MemberShow, MemberEdit, MemberCreate } from './pages/member';
import { SourceEdit, SourceList, SourceShow } from './pages/source';
import { RegionEdit, RegionList, RegionShow } from './pages/region';
import { KeywordCreate, KeywordEdit, KeywordList, KeywordShow } from './pages/keyword';
import { KolCreate, KolEdit, KolList, KolShow } from './pages/kol';
import { ManuallyChannelCreate, ManuallyChannelEdit, ManuallyChannelList, ManuallyChannelShow } from './pages/manuallyChannel';
import { ScheduleCreate, ScheduleEdit, ScheduleList, ScheduleShow } from './pages/schedule';
import { ChannelEdit, ChannelList, ChannelShow } from './pages/channel';
import { TargetEdit, TargetList, TargetShow } from './pages/target';
import { SearchLogList } from './pages/searchLog';

import ChannelIcon from '@mui/icons-material/Theaters';
import TargetlIcon from '@mui/icons-material/VideoLibrary';
import SearchLogIcon from '@mui/icons-material/FormatListNumbered';
import SourceIcon from '@mui/icons-material/Cast';
import RegionIcon from '@mui/icons-material/Public';
import KeywordIcon from '@mui/icons-material/YoutubeSearchedFor';
import KolIcon from '@mui/icons-material/TheaterComedy';
import ManuallyChannelIcon from '@mui/icons-material/AddToQueue';
import ScheduleIcon from '@mui/icons-material/EventNote';
import MemberIcon from '@mui/icons-material/SupervisedUserCircle';
import './App.css';
import { yellow } from '@mui/material/colors';

const authProvider = AuthProvider();
const dataProvider = DataProvider();

const theme = {
    ...defaultTheme,
    palette:
	{
		secondary:
		{
			main: yellow[500]
		}
    },
};

const App = () => (
//	<Admin theme={theme} dataProvider={dataProvider} authProvider={authProvider} i18nProvider={i18nProvider} title='管理系統' dashboard={dashboard} disableTelemetry>
	<Admin theme={theme} dataProvider={dataProvider} authProvider={authProvider} i18nProvider={i18nProvider} title='管理系統' disableTelemetry>
		{permissions => [
			<Resource key='kol' name='kol' list={permissions.kolView ? KolList : undefined} show={permissions.kolView ? KolShow : undefined} edit={permissions.kolEdit ? KolEdit : undefined} create={permissions.kolCreate ? KolCreate : undefined} options={{label:'KOL'}} icon={KolIcon} />,
			<Resource key='channel' name='channel' list={permissions.channelView ? ChannelList : undefined} show={permissions.channelView ? ChannelShow : undefined} edit={permissions.channelEdit ? ChannelEdit : undefined} options={{label:'追蹤頻道'}} icon={ChannelIcon} />,
			<Resource key='target' name='target' list={permissions.targetView ? TargetList : undefined} show={permissions.targetView ? TargetShow : undefined} edit={permissions.targetEdit ? TargetEdit : undefined} options={{label:'追蹤目標'}} icon={TargetlIcon} />,
			<Resource key='searchLog' name='searchLog' list={permissions.targetView ? SearchLogList : undefined} options={{label:'搜尋排名'}} icon={SearchLogIcon} />,
			<Resource key='source' name='source' list={permissions.sourceView ? SourceList : undefined} show={permissions.sourceView ? SourceShow : undefined} edit={permissions.sourceEdit ? SourceEdit : undefined} options={{label:'資料來源'}} icon={SourceIcon} />,
			<Resource key='region' name='region' list={permissions.regionView ? RegionList : undefined} show={permissions.regionView ? RegionShow : undefined} edit={permissions.regionEdit ? RegionEdit : undefined} options={{label:'區域'}} icon={RegionIcon} />,
			<Resource key='keyword' name='keyword' list={permissions.keywordView ? KeywordList : undefined} show={permissions.keywordView ? KeywordShow : undefined} edit={permissions.keywordEdit ? KeywordEdit : undefined} create={permissions.keywordCreate ? KeywordCreate : undefined} options={{label:'關鍵字'}} icon={KeywordIcon} />,
			<Resource key='manuallyChannel' name='manuallyChannel' list={permissions.manuallyChannelView ? ManuallyChannelList : undefined} show={permissions.manuallyChannelView ? ManuallyChannelShow : undefined} edit={permissions.manuallyChannelEdit ? ManuallyChannelEdit : undefined} create={permissions.manuallyChannelCreate ? ManuallyChannelCreate : undefined} options={{label:'手動新增頻道'}} icon={ManuallyChannelIcon} />,
			<Resource key='schedule' name='schedule' list={permissions.scheduleView ? ScheduleList : undefined} show={permissions.scheduleView ? ScheduleShow : undefined} edit={permissions.scheduleEdit ? ScheduleEdit : undefined} create={permissions.scheduleCreate ? ScheduleCreate : undefined} options={{label:'排程工作'}} icon={ScheduleIcon} />,
			<Resource key='member' name='member' list={MemberList} show={MemberShow} edit={permissions.memberEdit ? MemberEdit : undefined} create={permissions.memberCreate ? MemberCreate : undefined} options={{label:'管理員'}} icon={MemberIcon} />,
			<Resource key='regionAll' name='regionAll' />,
			<Resource key='keywordAll' name='keywordAll' />,
			<Resource key='kolAll' name='kolAll' />,
			<Resource key='scheduleTargetLog' name='scheduleTargetLog' />,
			<Resource key='memberLog' name='memberLog' />,
			<Resource key='memberPermission' name='memberPermission' />
		]}
	</Admin>
);

export default App;
